$(document).ready(function () {

    const slidersReview = document.querySelectorAll(".SwiperSliderReview");

    if (slidersReview.length) {
      slidersReview.forEach((swiperContainer) => {
        const swiperControlId = swiperContainer.getAttribute("data-swiper-id");
        const swiperControls = document.querySelector(
          `.SwiperMeta[data-swiper-id="${swiperControlId}"]`
        );

        const navigationPrev = swiperControls.querySelector(".swiperArrowPrev");
        const navigationNext = swiperControls.querySelector(".swiperArrowNext");
        const scrollbarEl = swiperControls.querySelector('.swiper-scrollbar');

        const swiperInstance = new Swiper(swiperContainer, {
          spaceBetween: 30,
          resizeObserver: true,
          navigation: {
            prevEl: navigationPrev,
            nextEl: navigationNext,
          },
            scrollbar: {
            el: scrollbarEl,
            draggable: true,
          },
          updateOnWindowResize: true,
          breakpoints: {
            0: {
              slidesPerView: 1,
              slidesPerGroup: 1,
            },
            768: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            1200: {
              slidesPerView: 3,
              slidesPerGroup: 3,
            },
          },
        });
      });
    }
});